// extracted by mini-css-extract-plugin
module.exports = {"body":"Text_body__34AFR"};